import React,{useState,useEffect,useRef} from 'react'
import axios from '../plugins/axios'
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Toast from '../plugins/useToast';
import { useRecoilState } from 'recoil';
import { isFromSearchState, selectBedInfoState, trendZoomState } from '../plugins/recoil';
import { checkEmptyValue } from '../plugins/common';
import TrendWave from './TrendReview/Wave/index';
import Arrhythmia from './TrendReview/Arrhythmia';
import TabularTrend from './TrendReview/TabularTrend';
import GraphicTrend from './TrendReview/GraphicTrend';
import Strip from './TrendReview/Strip';
import Timeline from './TrendReview/Timeline';
import TimelineDateModal from './TrendReview/TimelineDateModal';
import MeasureTime from './TrendReview/Wave/Measure/index';
import TrendStripModal from './TrendReview/TrendStripModal';
import HalfMenus from './halfMenus';
import {ReactComponent as IconClose} from '../assets/icons/ic-close.svg'
import {ReactComponent as IconArrowUp} from '../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrhythmia} from '../assets/icons/ic-trendReview-arrhythmia-alarm.svg'
import {ReactComponent as IconTabularTrend} from '../assets/icons/ic-trendReview-tabular-trend.svg'
import {ReactComponent as IconGraphicTrend} from '../assets/icons/ic-trendReview-graphic-trend.svg'
import {ReactComponent as IconStrip} from '../assets/icons/ic-trendReview-strip.svg'
import {ReactComponent as IconErrorYellow} from '../assets/icons/ic-error-yellow.svg';
import {ReactComponent as IconRight} from '../assets/icons/ic-calendar-right.svg'
import {ReactComponent as IconLeft} from '../assets/icons/ic-calendar-left.svg'

const TrendReview = ({isTrendFull, onClose, onAlarmReview, onSetting,onMeasurements, handleFullScreen}) => {
    const { t } = useTranslation();
    const isFristRender = useRef(true); // 최초 렌더링 여부 확인용
    const wrapperRef = useRef(null);    
    const searchModalRef = useRef(null);
    const [selectBedInfo, ] = useRecoilState(selectBedInfoState)        
    const [trendZoom, setTrendZoom] = useRecoilState(trendZoomState)  
    const [isFromSearch, ] = useRecoilState(isFromSearchState)
    const [patientHistories, setPatientHistories] = useState([])  
    const [patientLatestHistory, setPatientLatestHistory] = useState(null)
    const [alarmList,setAlarmList] = useState([])    
    const [startDate, setStartDate] = useState(null) //시작 날짜
    const [endDate, setEndDate] = useState(null) //종료 날짜
    const [waveStartDate, setWaveStartDate] = useState(null)
    const [isTrendClose, setIsTrendClose] = useState(false)
    const [trendData, setTrendData] = useState(); //TrendWave 데이터
    const [timeSettings, setTimeSettings] = useState({
        "60m": { count: 120, columns: 5, rows: 24, yOffset: 20,  subtract : 3600,},        
        "40m": { count: 80, columns: 5, rows: 16, yOffset: 20,  subtract : 2400},        
        "15m": { count: 28, columns: 5, rows: 6, yOffset: 20,  subtract : 900}, 
    });
    const [trendWaveType, setTrendWaveType] = useState('LEADⅡ');
    const [selectDetailView, setselectDetailView] = useState('Arrhythmia');    
    const [selectBoxTimeInfo, setSelectBoxTimeInfo] = useState(null) //선택된 박스 시간 정보.    
    const [loading,setLoading] = useState(false);    
    const [isDoubleClick, setIsDoubleClick] = useState(false) //클릭 유무 체크
    const [doubleClickType, setDoubleClickType] = useState() //타입 체크    
    const [doubleClickData, setDoubleClickData] = useState() //데이터 세팅
    const [doubleClickWidth,setDoubleClickWidth] = useState()
    const [isTimeLineFlag, setIsTimeLineFlag] = useState('');    
    const [isTimeSettings, setIsTimeSettings] = useState(false); //TimeLine Setting show / hide
    const [timeLineDuration, setTimeLineDuration] = useState(3);    
    const [currentUserInfo, setCurrentUserInfo] = useState({}); // 현재 시간 사용자 정보    

    const [canSearchMoves, setCanSearchMoves] = useState({
        trendPrev : false,
        trendNext : false,
        timeLineDurationPrev : false,
        timeLineDurationNext : false,
        timeTripplePrev : false,
        timeTrippleNext : false
    });

    const [isStripPrint, setIsStripPrint] = useState(false)    

    // 환자 히스토리.
    const getPatientHistory = async () => {
        try {
            const res = await axios.get(`/device/${selectBedInfo?.deviceId}/patient/histories?startDate=${moment(startDate).utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endDate=${moment(endDate).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`)
            if (res.code != '200') throw res
            setPatientHistories(res.data.histories)     
            setPatientLatestHistory(res.data.latestHistory);
        } catch (err) { console.warn(err) }
    }

    // Alarm List 가져오기.
    const getAlarmList = async () => {
        try {
            const res = await axios.get(`/trend/alarm/event?serialNo=${selectBedInfo?.serial}&startTime=${moment(startDate).utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment(endDate).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`)
            if (res.code != '200') throw res
            const alarmData = res.data.events.map((alarm, idx) => {
                return {
                    ...alarm,
                    alarmNum: idx,
                    startTime: moment(alarm.startTime).format('YYYY-MM-DD HH:mm:ss'),
                    endTime: moment(alarm.endTime).format('YYYY-MM-DD HH:mm:ss'),
                }
            })
            setAlarmList(alarmData);            
        } catch (err) { 
            console.warn(err)           
        }
    }
    
    // Serach 일때 AlarmList 가져오기   
    //#region 
    //1. selectBedInfo의 histories를 입퇴원 기준으로 가져온다.
    //2. startDate와 endDate의 기준으로 어떤 환자가 histories에 포함되는지 전부 가져온다.
    //3. 시간대 별로 입퇴원 시간을 판단하여 serial번호를 가져오고 startDate endDate 기준으로 퇴원시간이나 시리얼 번호가 달라지면 딱 거기까지만 데이터를 가져온다.
    //  EX) startDate가 1시 endDate가 4시인 경우 A환자의 A시리얼 번호로 입퇴원이 12시 30분부터 2시까지이고 다시 A환자의 B시리얼 번호로 입퇴원이 2시부터 4시까지인경우 
    //      1시부터 2시까지 A시리얼 번호로 데이터를 가져오기 / 2시부터 3시까지 B시리얼로 데이터를 가져오기
    //      2가지의 데이터를 병합하기.      
    //병합한 데이터를 아래 alarmData 로직처럼 넣어서 setAlarmList에 넣기
    //#endregion
    const getIsSearchAlarmList = async () => {
        try {
            const deviceHistory = selectBedInfo?.deviceHistory || [];
            const searchStart = moment(startDate);
            const searchEnd = moment(endDate);

            // 1. 환자별 입퇴원 기간 생성 (시리얼 기준)
            const periods = [];
            const sortedHistory = deviceHistory.slice().sort((a, b) => moment(a.createdAt) - moment(b.createdAt));
            let currentPeriod = null;
            sortedHistory.forEach(h => {
                if (h.action === 'ADMITTED') {
                    currentPeriod = {
                        serial: h.serial,
                        start: moment(h.createdAt),
                        end: null
                    };
                } else if (h.action === 'UNASSIGNED' && currentPeriod) {
                    currentPeriod.end = moment(h.createdAt);
                    periods.push(currentPeriod);
                    currentPeriod = null;
                }
            });
            if (currentPeriod && !currentPeriod.end) {
                currentPeriod.end = moment(); // 현재까지 입원
                periods.push(currentPeriod);
            }

            // 2. 검색 구간과 겹치는 기간만 추출
            const plans = [];
            periods.forEach(period => {
                const planStart = moment.max(searchStart, period.start);
                const planEnd = moment.min(searchEnd, period.end);
                if (planEnd.isAfter(planStart)) {
                    plans.push({
                        serial: period.serial,
                        start: planStart,
                        end: planEnd
                    });
                }
            });

            // 3. 각 구간별로 알람 데이터 가져오기
            let allEvents = [];
            for (const plan of plans) { 
                const res = await axios.get(`/trend/alarm/event?serialNo=${plan.serial}&startTime=${plan.start.utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${plan.end.utc().format('YYYY-MM-DDTHH:mm:ss')}Z`);
                if (res.code != '200') throw res;
                const events = res.data.events.map((alarm, idx) => ({
                    ...alarm,
                    alarmNum: idx,
                    startTime: moment(alarm.startTime).format('YYYY-MM-DD HH:mm:ss'),
                    endTime: moment(alarm.endTime).format('YYYY-MM-DD HH:mm:ss'),
                }));
                allEvents = allEvents.concat(events);
            }

            // 4. 시간순 정렬 및 중복 제거
            const sortedEvents = allEvents
                .sort((a, b) => moment(a.startTime) - moment(b.startTime))
                .filter((item, idx, arr) => idx === 0 || item.startTime !== arr[idx - 1].startTime);
            
            setAlarmList(sortedEvents);
        } catch (err) {
            console.warn(err);
            setAlarmList([]);
        }
    };

    // TimeLine 버튼 클릭 시 변경.
    const handleChangeTime = (flag) => {        
        switch(flag) {
            case 'prevTriple':                
                    setStartDate(new Date(moment(startDate).subtract(1, 'days')))
                    setEndDate(new Date(moment(endDate).subtract(1, 'days')))
                    setIsTimeLineFlag('prevTriple')
                break;
            case 'prevDuration':                
                    setStartDate(new Date(moment(startDate).subtract(timeLineDuration, 'hours')))
                    setEndDate(new Date(moment(endDate).subtract(timeLineDuration, 'hours')))
                    setIsTimeLineFlag('prevDuration')
                break;
            case 'prev':                                        
                    const prevTime = new Date(moment(waveStartDate).subtract(isTrendFull ? (isTrendClose ? 60 : 40) : 15 , 'minutes'))  
                    const prevSameTime = moment(startDate).subtract(isTrendFull ? (isTrendClose ? 60 : 40) : 15 , 'minutes');
                    if(moment(prevTime).isSame(prevSameTime)){                        
                        setWaveStartDate(new Date(moment(endDate).subtract(timeLineDuration, 'hours').subtract(isTrendFull ? (isTrendClose ? 60 : 40) : 15 , 'minutes')))
                        setStartDate(new Date(moment(startDate).subtract(timeLineDuration, 'hours')))
                        setEndDate(new Date(moment(endDate).subtract(timeLineDuration, 'hours'))) 
                    } else if (moment(prevTime).isBefore(moment(startDate))) {                        
                        setWaveStartDate(new Date(moment(startDate)))                                               
                    } else{
                        setWaveStartDate(prevTime)
                    }                    
                break;
            case 'next':
                    const nextTime = new Date(moment(waveStartDate).add(isTrendFull ? (isTrendClose ? 60 : 40) : 15 , 'minutes'))                                                    
                    const nextSameTime = moment(endDate);
                    if(moment(nextTime).isSame(moment(nextSameTime))){
                        setStartDate(new Date(moment(startDate).add(timeLineDuration, 'hours')))
                        setEndDate(new Date(moment(endDate).add(timeLineDuration, 'hours')))
                        setWaveStartDate(new Date(moment(startDate).add(timeLineDuration, 'hours')))
                    }else if (moment(nextTime).isAfter(moment(endDate).subtract(isTrendFull ? (isTrendClose ? 60 : 40) : 15 , 'minutes'))) {                        
                        setWaveStartDate(new Date(moment(endDate).subtract(isTrendFull ? (isTrendClose ? 60 : 40) : 15 , 'minutes')))
                    }else{
                        setWaveStartDate(nextTime)
                    }                    
                break;
            case 'nextDuration':         
                    //현재 시간에서 endDate 시간에 add(isTrendFull ? (isTrendClose ? 60 : 40) : 15 , 'minutes')를 한 시간이 지났을때는 다음으로 이동 가능                    
                    if(moment().isAfter(moment(endDate).add(isTrendFull ? (isTrendClose ? 60 : 40) : 15 , 'minutes'))){
                        setStartDate(new Date(moment(startDate).add(timeLineDuration, 'hours')))
                        setEndDate(new Date(moment(endDate).add(timeLineDuration, 'hours')))                        
                        setIsTimeLineFlag('nextDuration')
                    }
                    // if (moment().isAfter(moment(endDate).add(timeLineDuration, 'hours'))) {
                    //     setStartDate(new Date(moment(startDate).add(timeLineDuration, 'hours')))
                    //     setEndDate(new Date(moment(endDate).add(timeLineDuration, 'hours')))                        
                    //     setIsTimeLineFlag('nextDuration')
                    // }
                break;
            case 'nextTriple':
                    setStartDate(new Date(moment(startDate).add(1, 'days')))
                    setEndDate(new Date(moment(endDate).add(1, 'days')))
                    setIsTimeLineFlag('nextTriple')
                break;
            default : 
                // console.log('[handleChangeStartDate] flag',flag);
                break;
        }
    }

    // Trend Wave 데이터 가져오기. 
    const handleTrendData = async () => {
        try{
            setLoading(true);
            
            const waveRes = await axios.get(`/trend/waveforms?serialNo=${selectBedInfo?.serial}&type=${trendWaveType}&startTime=${moment(waveStartDate).utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment(waveStartDate).utc().add(timeSettings[trendZoom]['subtract'], 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`)
            const Wave = setTrendWaveList('wave',waveRes.data.waveformData.waveforms,`${moment(waveStartDate).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,`${moment(waveStartDate).utc().add(timeSettings[trendZoom]['subtract'], 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`)
            
            const hrRes = await axios.get(`/trend/vitals?serialNo=${selectBedInfo?.serial}&type=1&startTime=${moment(waveStartDate).utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment(waveStartDate).utc().add(timeSettings[trendZoom]['subtract'], 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`);
            const HeartRate = setTrendWaveList('hr',hrRes.data.timeValues,`${moment(waveStartDate).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,`${moment(waveStartDate).utc().add(timeSettings[trendZoom]['subtract'], 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`)
            // const HeartRate = hrRes.data.timeValues || [];

            //console.log({Wave : Wave, HeartRate : HeartRate});

            setTrendData({Wave : Wave, HeartRate : HeartRate}); 
        }
        catch(err){
            console.warn('handleTrendWave Error : ', err);
        }
    }
    
    //Search로 들어왔을 때 데이터 가져오기
    //#region 
    /*                
        ※ 환자의 입퇴원 시간은 selectBedInfo의 deviceHistory에 Array로 있으며, Array안에는 
        action / createdAt / deviceId / devicePatientId / patientId / patientName / serial이 있으며
        action은 ADMITTED와 UNASSIGNED로 되어있음
        createdAt은 시간정보가 들어있는데 ADMITTED / UNASSIGNED 시간임
        serial 번호로 api 호출을 하여야 하니 이 3가지를 가장 중점으로 데이터로 비교해야됨.
        
        1. 현재 선택된 환자의 입퇴원 시간을 가져오기 
            => Transfer 했을 경우 입퇴원 시간은 여러개 일 수 있으니 입퇴원 시간이 여러개인걸 고려한다.
        2. 현재 waveStartDate과 waveEndData (zoom으로 시간 구성)을 세팅한다.
        3. 1,2번의 데이터가 세팅 되면 현재 입퇴원 시간과 waveStartDate, waveEndData의 시간을 비교하여 해당 시간에 속해있는지 체크한다.                

        [CASE]
        CASE A) wave 검색 시간이 환자의 입퇴원 시간에 포함될 경우 
            - selectBedInfo의 입퇴원 serial 번호를 가져와서 wave, hr 데이터를 가져와서 표기한다.
        CASE B) wave 검색 시간이 포함은 되지만 serial 번호가 다를 경우
            - 시간 검색을 하여 포함 되는 시간의 시리얼 번호를 각각 데이터를 표기하여 wave, hr 데이터를 가져온다.
                EX) waveStartDate부터 A자리의 퇴원 시간까지 가져오고 B자리의 입원부터 waveEndData 시간으로 2번 데이터를 가져온다.
            - 시간을 여러번 가져왔을 때 wave와 hr 데이터를 timestamp 기준으로 데이터를 결합 시킨다.
        CASE C) wave 검색 시간은 포함 되지만 기간이 짧게 포함 되는 경우
            - 포함된 시간 정보만 wave와 hr을 가져온다.
        
        4. CASE에서 정리된 데이터를 setTrendWaveList에 waveStartDate와 waveEndData 기준으로 세팅을 다시 한다.
        5. setTrendData({Wave : Wave, HeartRate : HeartRate}); 세팅한다.
    */
    //#endregion
    const handleIsSearchTrendData = async () => {        
        try {
            setLoading(true);
            
            // 1. 현재 선택된 환자의 입퇴원 시간 가져오기
            const deviceHistory = selectBedInfo?.deviceHistory || [];            

            // 2. waveStartDate와 waveEndDate 설정
            const searchStartTime = moment(waveStartDate);
            const searchEndTime = moment(waveStartDate).add(timeSettings[trendZoom]['subtract'], 'seconds');

            // 3. 환자별 입퇴원 기간 생성
            const patientPeriods = [];
            
            // 환자별로 그룹화
            const groupedByPatient = deviceHistory.reduce((acc, history) => {
                if (!acc[history.patientId]) {
                    acc[history.patientId] = [];
                }
                acc[history.patientId].push(history);
                return acc;
            }, {});            

            // 각 환자별로 입퇴원 기간 생성
            Object.keys(groupedByPatient).forEach(patientId => {
                const patientHistories = groupedByPatient[patientId].sort((a, b) => 
                    moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()
                );

                for (let i = 0; i < patientHistories.length; i++) {
                    const history = patientHistories[i];
                    
                    if (history.action === 'ADMITTED') {
                        // 같은 환자의 다음 UNASSIGNED 찾기
                        const nextUnassigned = patientHistories.slice(i + 1).find(h => h.action === 'UNASSIGNED');

                        //moment(selectBedInfo.endTime)
                        const period = {
                            patientId: history.patientId,
                            patientName: history.patientName,
                            serial: history.serial,
                            admittedTime: moment(history.createdAt),
                            unassignedTime: nextUnassigned ? moment(nextUnassigned.createdAt) : null,
                            startTime: moment(history.createdAt),
                            //endTime: nextUnassigned ? moment(nextUnassigned.createdAt) : moment() // 현재 시간까지
                            endTime: nextUnassigned ? moment(nextUnassigned.createdAt) : moment(selectBedInfo.endTime) // 현재 시간까지
                        };
                        
                        patientPeriods.push(period);
                    }
                }
            });

            // 시간순으로 정렬 
            patientPeriods.sort((a, b) => a.startTime.valueOf() - b.startTime.valueOf());

            // 전체 환자 기간의 최소/최대 시간 계산
            const earliestAdmission = patientPeriods.length > 0 ? moment.min(patientPeriods.map(p => p.startTime)) : moment();
            const latestDischarge = patientPeriods.length > 0 ? moment.max(patientPeriods.map(p => p.endTime)) : moment();

            // Navigation 가능 여부 체크
            const currentWaveStart = moment(waveStartDate);
            const currentWaveEnd = moment(waveStartDate).add(timeSettings[trendZoom]['subtract'], 'seconds');

            // Trend Navigation (15m, 40m, 60m 기준)
            const trendMinutes = isTrendFull ? (isTrendClose ? 60 : 40) : 15;
            const trendPrevStart = moment(currentWaveStart).subtract(trendMinutes, 'minutes');
            const trendNextEnd = moment(currentWaveEnd).add(trendMinutes, 'minutes');            

            // Timeline Duration Navigation
            const timeLineDurationPrevStart = moment(startDate).subtract(timeLineDuration, 'hours');
            const timeLineDurationNextEnd = moment(endDate).add(timeLineDuration, 'hours');

            // Triple Navigation (하루 기준)
            const timeTripplePrevStart = moment(startDate).subtract(1, 'days');
            const timeTrippleNextEnd = moment(endDate).add(1, 'days');

            const newCanSearchMoves = {
                trendPrev: checkTimeHasPatientData(trendPrevStart, currentWaveStart),
                trendNext: checkTimeHasPatientData(currentWaveEnd, trendNextEnd),
                timeLineDurationPrev: checkTimeHasPatientData(timeLineDurationPrevStart, moment(startDate)),
                timeLineDurationNext: checkTimeHasPatientData(moment(endDate), timeLineDurationNextEnd),
                timeTripplePrev: checkTimeHasPatientData(timeTripplePrevStart, moment(timeTripplePrevStart).add(timeLineDuration, 'hours')),
                timeTrippleNext: checkTimeHasPatientData(moment(timeTrippleNextEnd).subtract(timeLineDuration, 'hours'), timeTrippleNextEnd),
                boundaries: {
                    earliestAdmission,
                    latestDischarge,
                    trendMinutes,
                    timeLineDuration
                }
            };

            // 특정 시간 범위에 환자 데이터가 있는지 확인하는 함수
            function checkTimeHasPatientData(rangeStart, rangeEnd) {
                // 환자 기간들 중에서 해당 시간 범위와 겹치는 것이 있는지 확인
                return patientPeriods.some(period => {
                    // 겹치는 조건: 범위 시작 < 기간 끝 && 범위 끝 > 기간 시작
                    return rangeStart.isBefore(period.endTime) && rangeEnd.isAfter(period.startTime);
                });
            }
            // function checkTimeHasPatientData(rangeStart, rangeEnd) {
            //     return patientPeriods.some(period => {
            //         console.log(
            //             'rangeStart', rangeStart.format(),
            //             'rangeEnd', rangeEnd.format(),
            //             'periodStart', period.startTime.format(),
            //             'periodEnd', period.endTime.format()
            //         );

            //         console.log('rangeStart.isBefore(period.endTime) : ', rangeStart.isBefore(period.endTime));
            //         console.log('rangeEnd.isAfter(period.startTime) : ', rangeEnd.isAfter(period.startTime));

            //         return rangeStart.isBefore(period.endTime) && rangeEnd.isAfter(period.startTime);
            //     });
            // }            

            setCanSearchMoves(newCanSearchMoves);

            // 4. 검색 시간과 겹치는 기간들 찾기
            const overlappingPeriods = patientPeriods.filter(period => {
                // 겹치는 조건: 검색 시작 < 기간 끝 && 검색 끝 > 기간 시작
                return searchStartTime.isBefore(period.endTime) && searchEndTime.isAfter(period.startTime);
            });

            if (overlappingPeriods.length === 0) {
                console.warn('검색 시간과 겹치는 환자 기간이 없습니다.');
                const wave = setTrendWaveList('wave',[],searchStartTime.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',searchEndTime.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z');
                const heartRate = setTrendWaveList('hr',[],searchStartTime.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',searchEndTime.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z');
                setTrendData({ Wave: wave, HeartRate: heartRate });
                return;
            }

            // 5. 각 겹치는 기간별로 데이터 수집 계획 생성
            const dataCollectionPlans = [];

            overlappingPeriods.forEach(period => {
                // 실제 겹치는 시간 범위 계산
                const actualStartTime = moment.max(searchStartTime, period.startTime);
                const actualEndTime = moment.min(searchEndTime, period.endTime);

                if (actualEndTime.isAfter(actualStartTime)) {
                    dataCollectionPlans.push({
                        serial: period.serial,
                        patientName: period.patientName,
                        startTime: actualStartTime,
                        endTime: actualEndTime,
                        period: period
                    });
                }
            });

            // console.log('데이터 수집 계획:', dataCollectionPlans.map(plan => ({
            //     patient: plan.patientName,
            //     serial: plan.serial,
            //     start: plan.startTime.format('YYYY-MM-DD HH:mm:ss'),
            //     end: plan.endTime.format('YYYY-MM-DD HH:mm:ss')
            // })));

            // 6. 각 계획별로 데이터 수집
            const allWaveData = [];
            const allHrData = [];

            for (const plan of dataCollectionPlans) {
                try {
                    // Wave 데이터 수집
                    const waveRes = await axios.get(`/trend/waveforms?serialNo=${plan.serial}&type=${trendWaveType}&startTime=${plan.startTime.utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${plan.endTime.utc().format('YYYY-MM-DDTHH:mm:ss')}Z`);
                    
                    if (waveRes.data?.waveformData?.waveforms) {
                        allWaveData.push(...waveRes.data.waveformData.waveforms);
                    }

                    // HR 데이터 수집
                    const hrRes = await axios.get(`/trend/vitals?serialNo=${plan.serial}&type=1&startTime=${plan.startTime.utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${plan.endTime.utc().format('YYYY-MM-DDTHH:mm:ss')}Z`);
                    
                    if (hrRes.data?.timeValues) {
                        allHrData.push(...hrRes.data.timeValues);
                    }

                    // console.log(`${plan.patientName} (${plan.serial}) 데이터 수집 완료:`, {
                    //     waveCount: waveRes.data?.waveformData?.waveforms?.length || 0,
                    //     hrCount: hrRes.data?.timeValues?.length || 0
                    // });

                } catch (err) {
                    console.warn(`${plan.patientName} (${plan.serial}) 데이터 수집 실패:`, err);
                }
            }

            // 7. timestamp 기준으로 데이터 정렬 및 중복 제거
            const sortedWaveData = allWaveData
                .sort((a, b) => moment(a.timestamp).valueOf() - moment(b.timestamp).valueOf())
                .filter((item, index, arr) => {
                    // 같은 timestamp의 중복 제거
                    return index === 0 || !moment(item.timestamp).isSame(moment(arr[index - 1].timestamp));
                });

            const sortedHrData = allHrData
                .sort((a, b) => moment(a.timestamp).valueOf() - moment(b.timestamp).valueOf())
                .filter((item, index, arr) => {
                    // 같은 timestamp의 중복 제거
                    return index === 0 || !moment(item.timestamp).isSame(moment(arr[index - 1].timestamp));
                });

            console.log('최종 데이터 수집 결과:', {
                waveCount: sortedWaveData.length,
                hrCount: sortedHrData.length,
                waveTimeRange: sortedWaveData.length > 0 ? {
                    start: moment(sortedWaveData[0].timestamp).format('YYYY-MM-DD HH:mm:ss'),
                    end: moment(sortedWaveData[sortedWaveData.length - 1].timestamp).format('YYYY-MM-DD HH:mm:ss')
                } : null,
                hrTimeRange: sortedHrData.length > 0 ? {
                    start: moment(sortedHrData[0].timestamp).format('YYYY-MM-DD HH:mm:ss'),
                    end: moment(sortedHrData[sortedHrData.length - 1].timestamp).format('YYYY-MM-DD HH:mm:ss')
                } : null
            });

            // 8. setTrendWaveList로 최종 데이터 가공
            const Wave = setTrendWaveList(
                'wave', 
                sortedWaveData, 
                searchStartTime.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
                searchEndTime.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z'
            );

            const HeartRate = setTrendWaveList(
                'hr', 
                sortedHrData, 
                searchStartTime.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
                searchEndTime.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z'
            );

            // 9. 최종 데이터 설정
            setTrendData({ Wave: Wave, HeartRate: HeartRate });

        } catch (err) {
            // console.warn('handleIsSearchTrendData Error:', err);
        }
    }

    // Trend Wave 빈 데이터 생성 및 추가.
    const setTrendWaveList = (type,data, startTime, endTime) => {
        // 시작 시간과 끝 시간을 moment로 변환
        const start = moment(startTime).startOf("second");
        const end = moment(endTime).startOf("second");       
    
        // 시작 시간부터 끝 시간까지 초 단위로 빈 데이터 생성
        const allSeconds = [];
        let current = start.clone();
        while (current < end) {
            allSeconds.push(current.format());
            current.add(1, "second");
        }        
    
        // 실제 데이터를 Timestamp : value 형태로 변환        
        const groupedBySecond = data.reduce((acc, item) => {
            const secondKey = moment(item.timestamp).startOf("second").format();  
            acc[secondKey] = (type == 'wave' ? item.samples : (item.value !== undefined && item.value !== null ? item.value : []));
            return acc;
        }, {});        

        // if(type == 'hr'){
        //     console.log('show Data : ',groupedBySecond) 
        // }

        let completeResult = [];

        // 초 단위 데이터를 모두 포함하도록 병합
        if(type == 'wave'){
            completeResult = allSeconds.map((second) => ({
                createdAt: second,
                wave: groupedBySecond[second] || [], // 데이터가 없으면 빈 배열
            }));
        }else if(type == 'hr'){            
            completeResult = allSeconds.map((second) => ({
                timestamp: second,
                value: (groupedBySecond[second] !== undefined && groupedBySecond[second] !== null ? groupedBySecond[second] : []), // 데이터가 없으면 빈 배열
            }));
        }
    
        return completeResult;
    };

    // Trend Wave 선택 시 박스의 시작 시간 정보
    const handleSelectBoxTimeInfo = (selectBoxTimeInfo) => {
        setSelectBoxTimeInfo(selectBoxTimeInfo);
    }       

    const getCurrentUserInfo = () => {        
        const histories = patientHistories || [];
        const latestHistory = patientLatestHistory;
        const selectedTime = moment(selectBoxTimeInfo);       
        console.log('selectedTime : ',selectedTime); 

        // 1. histories 데이터가 없는 경우
        if (!histories || histories.length === 0) {
            if (!latestHistory) {                
                setCurrentUserInfo({ patientName: 'Not Admitted', flag: 'past' });
                return;
            }
                        
            if (latestHistory.action === 'ADMITTED') {                
                if (selectBedInfo?.patientId === latestHistory.patientId) {
                    setCurrentUserInfo({ ...latestHistory, flag: 'now' });
                } else {
                    setCurrentUserInfo({ ...latestHistory, flag: 'past' });
                }
            } else if (latestHistory.action === 'UNASSIGNED') {
                const historyTime = moment(latestHistory.createdAt);
                if (selectedTime.isBefore(historyTime)) {
                    setCurrentUserInfo({ ...latestHistory, flag: 'past' });
                } else {
                    setCurrentUserInfo({ patientName: 'Not Admitted', flag: 'past' });
                }
            } else {                              
                setCurrentUserInfo({ patientName: 'Not Admitted', flag: 'past' });
            }
            return;
        }

        // 2. histories에 데이터가 있는 경우 - 환자별 입퇴원 기간 생성
        const patientPeriods = [];
        
        // 환자별로 그룹화
        const groupedByPatient = histories.reduce((acc, history) => {
            if (!acc[history.patientId]) {
                acc[history.patientId] = [];
            }
            acc[history.patientId].push(history);
            return acc;
        }, {});

        console.log('groupedByPatient : ',groupedByPatient);

        // 각 환자별로 입퇴원 기간 생성
        Object.keys(groupedByPatient).forEach(patientId => {
            const patientHistories = groupedByPatient[patientId].sort((a, b) => 
                moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()
            );

            for (let i = 0; i < patientHistories.length; i++) {
                const history = patientHistories[i];
                
                if (history.action === 'ADMITTED') {
                    // 같은 환자의 다음 UNASSIGNED 찾기
                    const nextUnassigned = patientHistories.slice(i + 1).find(h => h.action === 'UNASSIGNED');
                    
                    const period = {
                        patientId: history.patientId,
                        admittedData: history,
                        unassignedData: nextUnassigned,
                        startTime: moment(history.createdAt),
                        endTime: nextUnassigned ? moment(nextUnassigned.createdAt) : moment(endDate)
                    };
                    
                    patientPeriods.push(period);
                } else if (history.action === 'UNASSIGNED') {
                    // ★ 추가: 검색 범위 이전에 입원한 환자의 퇴원 기록만 있는 경우
                    // 이 UNASSIGNED 이전에 같은 환자의 ADMITTED가 histories에 없으면
                    // 입원이 검색 범위 이전에 발생한 것이므로 기간을 생성
                    const hasPrecedingAdmitted = patientHistories.slice(0, i).some(h => 
                        h.action === 'ADMITTED'
                    );
                    
                    if (!hasPrecedingAdmitted) {
                        const period = {
                            patientId: history.patientId,
                            admittedData: history, // 환자 정보 표시용 (patientName 등 동일)
                            unassignedData: history,
                            startTime: moment(startDate), // 입원은 검색 범위 이전
                            endTime: moment(history.createdAt)
                        };
                        
                        patientPeriods.push(period);
                    }
                }
            }
        });

        // 시간순으로 정렬
        patientPeriods.sort((a, b) => a.startTime.valueOf() - b.startTime.valueOf());

        let found = null;
        for (const period of patientPeriods) {
            if (selectedTime.isSameOrAfter(period.startTime) && selectedTime.isSameOrBefore(period.endTime)) {
            const isCurrentPatientAdmitted = !period.unassignedData && latestHistory?.patientId === period.patientId;
            
            if (isCurrentPatientAdmitted && selectBedInfo?.patientId === period.patientId) {
                found = { ...latestHistory, flag: 'now' };
            } else {
                found = { ...period.admittedData, flag: 'past' };
            }
            break;
            }
        }

        // 선택한 시간이 어떤 기간에도 포함되지 않는 경우 처리
        if (!found) {
            // 1. UNASSIGNED만 있는 경우 (입원이 검색 범위 이전에 발생)
            const unassignedOnly = histories.filter(h => h.action === 'UNASSIGNED');
            for (const unassigned of unassignedOnly) {
                const unassignedTime = moment(unassigned.createdAt);
                if (selectedTime.isBefore(unassignedTime)) {
                    const hasAdmittedInPeriod = histories.some(h => 
                        h.action === 'ADMITTED' && 
                        h.patientId === unassigned.patientId &&
                        moment(h.createdAt).isSameOrAfter(moment(startDate))
                    );
                    
                    if (!hasAdmittedInPeriod) {
                        found = { ...unassigned, flag: 'past' };
                        break;
                    }
                }
            }

            // 2. 그래도 못찾았으면, 현재 시간은 어떤 환자에게도 할당되지 않은 시간임 
            if (!found) {                
                console.log('이거야?')
                setCurrentUserInfo({ patientName: 'Not Admitted', flag: 'past' });
                return;
            }
        }        

        // 최종 결과 설정
        setCurrentUserInfo(found);
    };

    // 더블 클릭 시 화면
    const handleDoubleClick = async (type,date) => {
        try{                                    
            let data;            
            let prevTime = 0;
            let nextTime = 30;            

            // 화면이 풀 화면일 경우 
            if(isTrendFull){
                prevTime = 30;
                nextTime = 60;
            }

            if(type == 'wave'){
                const waveRes = await axios.get(`/trend/waveforms?serialNo=${selectBedInfo?.serial}&type=${trendWaveType}&startTime=${moment(date).utc().subtract(prevTime, 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment(date).utc().add(nextTime, 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`)
                data = setTrendWaveList('wave',waveRes.data.waveformData.waveforms,`${moment(date).utc().subtract(prevTime, 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`,`${moment(date).utc().add(nextTime, 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`);
            }else if(type == 'hr'){
                const hrRes = await axios.get(`/trend/vitals?serialNo=${selectBedInfo?.serial}&type=1&startTime=${moment(date).utc().subtract(prevTime, 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment(date).utc().add(nextTime, 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`);
                data = setTrendWaveList('hr',hrRes.data.timeValues,`${moment(date).utc().subtract(prevTime, 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`,`${moment(date).utc().add(nextTime, 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`);                
            }

            const result = [];
            let batch = [];
        
            for (let i = 0; i < data.length; i++) {            
                batch.push(data[i]);    
                if (batch.length === 10 || i === data.length - 1) {
                    result.push(batch);
                    batch = [];
                }
            }

            setDoubleClickType(type)
            setDoubleClickData(result);
            setIsDoubleClick(true);
        }       
        catch(err){
            // console.warn('handleDoubleClick Error : ', err);
        }
    }

    // Trend Detail view 변경 시 Render
    const renderMenuContent = () => {
        if (selectDetailView == 'Arrhythmia') {
            return <Arrhythmia 
                        isTrendFull={isTrendFull} 
                        onClose={() => { setIsTrendClose(!isTrendClose) }}
                        selectBoxTimeInfo={selectBoxTimeInfo}
                        waveStartDate={waveStartDate}
                        waveEndDate={moment(waveStartDate).add(timeSettings[trendZoom]['subtract'], 'seconds')}
                        trendZoom={trendZoom}
                        patientHistories={patientHistories}
                        patientLatestHistory={patientLatestHistory}
                    />
        } else if (selectDetailView == 'Tabular Trend') {
            return <TabularTrend 
                        isTrendFull={isTrendFull} 
                        onClose={() => { setIsTrendClose(!isTrendClose) }}
                        selectBoxTimeInfo={selectBoxTimeInfo}
                        handleSelectBoxTimeInfo={handleSelectBoxTimeInfo}                            
                        waveStartDate={waveStartDate} 
                        waveEndDate={moment(waveStartDate).add(timeSettings[trendZoom]['subtract'], 'seconds')}       
                        trendZoom={trendZoom}      
                        handleTrendPrint={() => handleTrendPrint('tabular')}               
                    />;
        } else if (selectDetailView == 'Strip') {
            return <Strip 
                        isTrendFull={isTrendFull}
                        onClose={() => { setIsTrendClose(!isTrendClose) }}
                        selectBoxTimeInfo={selectBoxTimeInfo}                                     
                        patientHistories={patientHistories}
                        showStripPrint={() => setIsStripPrint(true)}
                    />;
        } else {
            return <GraphicTrend 
                        isTrendFull={isTrendFull} 
                        onClose={() => { setIsTrendClose(!isTrendClose) }}
                        selectBoxTimeInfo={selectBoxTimeInfo}
                        handleSelectBoxTimeInfo={handleSelectBoxTimeInfo}                            
                        waveStartDate={waveStartDate} 
                        waveEndDate={moment(waveStartDate).add(timeSettings[trendZoom]['subtract'], 'seconds')}       
                        trendZoom={trendZoom}
                        patientHistories={patientHistories}     
                    />;     
        }
    };

    // 타임라인 드래그 
    const handleDragTimeLine = (date) => {        
        setWaveStartDate(new Date(moment(date)))        
    }
    
    // 타임라인 Settings show / hide
    const handleTimeSettings = () => {
        setIsTimeSettings(true);
    }

    // 타임라인 Settings 저장
    const handleTimeLineSearch = (startDate, endDate, duration) => {
        setStartDate(new Date(moment(startDate)));
        setEndDate(new Date(moment(endDate)));
        setWaveStartDate(new Date(moment(endDate).subtract(isTrendFull ? (isTrendClose ? 60 : 40) : 15 , 'minutes')));
        setTimeLineDuration(duration);
        setIsTimeSettings(false);
    }

    // Print Handler 
    const handleTrendPrint = async (type,waves = []) => {
        //endTime 기준으로 15분 전 데이터 ~ endTime 까지만 보여줌.
        let waveEndTime = null, waveStratTime = null;
        if(isTrendFull){
            waveEndTime = `${moment.utc(waveStartDate).add(isTrendClose ? 60 : 40, 'minutes').format('YYYY-MM-DDTHH:mm:ss')}Z`;
            waveStratTime = `${moment.utc(waveEndTime).subtract(15, 'minutes').format('YYYY-MM-DDTHH:mm:ss')}Z`;
        }else{
            waveStratTime = `${moment.utc(waveStartDate).format('YYYY-MM-DDTHH:mm:ss')}Z`;
            waveEndTime = `${moment.utc(waveStartDate).add(timeSettings[trendZoom]['subtract'], 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`;
        }

        let setUrl = '';
        const windowFeatures = "width=1200,height=800,left=100,top=100,scrollbars=yes,resizable=yes";        

        if(type == 'tabular'){                        
            setUrl = `${window.location.origin}/print/trendform?deviceid=${selectBedInfo.deviceId}&starttime=${waveStratTime}&endtime=${waveEndTime}&selecttime=${moment.utc(selectBoxTimeInfo).format('YYYY-MM-DDTHH:mm:ss')}Z&leadtype=${trendWaveType}&type=tabular`
        }else if(type == 'strip'){
            setIsStripPrint(false);                        
            setUrl = `${window.location.origin}/print/trendform?deviceid=${selectBedInfo.deviceId}&starttime=${waveStratTime}&endtime=${waveEndTime}&selecttime=${moment.utc(selectBoxTimeInfo).format('YYYY-MM-DDTHH:mm:ss')}Z&leadtype=${trendWaveType}&type=strip&wave1=${waves[0]?.measureParameter || ''}&wave2=${waves[1]?.measureParameter || ''}`
        }

        const newWindow = window.open(setUrl, "popupWindow", windowFeatures);
        if (newWindow) {
            newWindow.focus();
        } else {
            Toast({ isSuccess: false, msg: t(`error.failOpenPage`) });
        }
    }    

    // 타임라인 설정 화면 버튼 클릭 시 
    useEffect(() => {
        if(isTimeSettings){
            //searchModalRef.current?.init();            
            searchModalRef.current?.setDate(startDate,endDate);
        }
    }, [isTimeSettings])    

    //TimeLine이 세팅되면 환자 이력, Alarm List 가져오기
    useEffect(() => {        
        if(moment(endDate).isValid()){
            if(isFromSearch){
                getIsSearchAlarmList();          
            }else{                
                getPatientHistory();       
                getAlarmList();
            }
        }
    }, [endDate])

    // 박스 선택 되면 현재 시간 이전의 사용자 정보 설정을 가져온다. 
    useEffect(() => {               
        if(moment(selectBoxTimeInfo).isValid()){            
            getCurrentUserInfo();            
        }        
    }, [selectBoxTimeInfo]);

    //타임라인 이동 버튼 클릭 시 이전 / 다음
    useEffect(() => {        
        if(isTimeLineFlag == 'prevDuration'){
            setWaveStartDate(new Date(moment(waveStartDate).subtract(timeLineDuration, 'hours')));
        }else if(isTimeLineFlag == 'nextDuration'){
            setWaveStartDate(new Date(moment(waveStartDate).add(timeLineDuration, 'hours')));
        }else if(isTimeLineFlag == 'prevTriple'){
            setWaveStartDate(new Date(moment(waveStartDate).subtract(1, 'days')));
        }else if(isTimeLineFlag == 'nextTriple'){
            setWaveStartDate(new Date(moment(waveStartDate).add(1, 'days')));
        }
       setIsTimeLineFlag(null);
    }, [isTimeLineFlag])

    //waveStartDate 변경 시
    useEffect(() => {
        if(isFristRender.current){
            isFristRender.current = false; // 최초 렌더링이 아님을 표시
        }

        if(moment(waveStartDate).isValid()){
            if(isFromSearch){
                handleIsSearchTrendData();
            }else{                
                handleTrendData();
            }
        }
    }, [waveStartDate,trendWaveType,trendZoom])

    //FullScreen 변경 시 상태값 체크
    useEffect(() => {
        if(!loading){
            setLoading(true);
        }      
        if(isTrendFull){            
            setTrendZoom(isTrendClose ? '60m' : '40m')
        }else {  
            setIsTrendClose(false)          
            setTrendZoom('15m')
        }        
        setIsDoubleClick(false);
    }, [isTrendFull])

    // 타임라인 zoom 이동 시 맨 앞 or 맨 끝 이동 했을때 검색 범위가 넘어가는 경우 밸리데이션 체크
    useEffect(() => {
        if (moment(waveStartDate).isValid() && trendZoom) {            
            const currentWaveStartDate = new Date(moment(waveStartDate));
            const minutes = isTrendFull ? (isTrendClose ? 60 : 40) : 15;
            
            // waveStartDate가 startDate보다 이전인 경우 - startDate에 add 시간으로 조정
            if (moment(currentWaveStartDate).isBefore(moment(startDate))) {
                const adjustedTime = new Date(moment(startDate).add(minutes, 'minutes'));
                setWaveStartDate(adjustedTime);
                return;
            }
            
            // waveStartDate + minutes가 endDate를 넘어가는 경우 - endDate 기준 subtract 시간으로 조정
            if (moment(currentWaveStartDate).add(minutes, 'minutes').isAfter(moment(endDate))) {
                const adjustedTime = new Date(moment(endDate).subtract(minutes, 'minutes'));                
                setWaveStartDate(adjustedTime);
                return;
            }
            
            // 현재 시간을 넘어가는 경우 - 현재 시간 기준 subtract 시간으로 조정
            if (moment(currentWaveStartDate).add(minutes, 'minutes').isAfter(moment())) {
                const adjustedTime = new Date(moment().subtract(minutes, 'minutes'));
                setWaveStartDate(adjustedTime);
                return;
            }
        }
    }, [trendZoom]);

    useEffect(() => {
        setLoading(true);
        if(isTrendClose){
            if(isTrendFull){
                setTrendZoom('60m')
            }else{
                setTrendZoom('15m')
            }
        }else{
            if(isTrendFull){                
                setTrendZoom('40m')
            }else{
                setTrendZoom('15m')
            }
        }
    }, [isTrendClose])
    
    useEffect(() => {
        if (selectBedInfo) {     
            if(isFromSearch){
                //검색된 데이터 일 경우 endTime 기준으로 시간을 세팅한다. (입원중인 경우 현재 / 퇴원중인 경우 과거 시간)                
                setStartDate(new Date(moment(selectBedInfo.endTime).subtract(3, 'hours'))) //timeline
                setEndDate(new Date(moment(selectBedInfo.endTime)))
                setWaveStartDate(new Date(moment(selectBedInfo.endTime).subtract(15, 'minutes')))
            }else{
                setStartDate(new Date(moment().subtract(3, 'hours')))
                setEndDate(new Date(moment()))
                setWaveStartDate(new Date(moment(selectBedInfo.endTime).subtract(15, 'minutes')))
                setTimeLineDuration(3); //selectBedInfo 변경 시 타임라인 duration 초기화
            }            
        }
    }, [selectBedInfo]);

    useEffect(() => {       
        if(wrapperRef.current){
            setDoubleClickWidth(wrapperRef.current?.getBoundingClientRect().width)
        } 
    }, [doubleClickData])    

    return (
        <div className="relative w-full h-full bg-black" style={{  }}>
            <div ref={wrapperRef} className="flex flex-col w-full h-full">
                <div className="flex relative justify-center text-white items-center h-[32px]" style={{ color: isFromSearch ? 'white' : '', background: isFromSearch ? '#01004B' : (currentUserInfo?.flag == 'past' ? '#02008B' : '#2C2C2C'), borderBottomWidth: 1, borderColor: '#4E4E4E' }}>
                    <div className={`flex items-center px-2 py-1`} style={{ background: isFromSearch ? 'linear-gradient(180deg, #2D2C81 0%, #141352 100%)' : (currentUserInfo?.flag == 'past' ? 'linear-gradient(180deg, #2927AC 0%, #100E95 100%)' : 'linear-gradient(180deg, #DEDEDE 0%, #9F9F9F 100%)'), height: '100%' }}>
                        <div className="flex items-center justify-center mr-2 w-[178px]" style={{ color: (currentUserInfo?.flag == 'past' || isFromSearch) ? 'white' : 'black', fontWeight: 500, fontSize: 24, lineHeight: '26.4px' }}>{isFromSearch ? '-' : checkEmptyValue(selectBedInfo.bedNumber.length <= 1 ? `0${selectBedInfo.bedNumber}` : selectBedInfo.bedNumber, 'BED-')}</div>                        
                        <div className="truncate" style={{ color: (currentUserInfo?.flag == 'past' || isFromSearch) ? 'white' : 'black', fontWeight: 200, fontSize: 16, lineHeight: '17.6px', minWidth: 301, maxWidth: 301 }}>                            
                            {
                                isFromSearch ? (
                                    <>
                                        {`${checkEmptyValue(selectBedInfo.patientName)} , ${checkEmptyValue(selectBedInfo.devicePatientId)}`}
                                    </>
                                ) : (
                                    <>
                                        {
                                            currentUserInfo?.flag == 'now' ? (
                                                <>
                                                    { selectBedInfo.patientId == null ? t('trend.notAdmitted') : selectBedInfo.nameDisplay === '1' ? checkEmptyValue(selectBedInfo.patientName) : selectBedInfo.nameDisplay === '2' ? checkEmptyValue(selectBedInfo.devicePatientId) : selectBedInfo.nameDisplay === '3' ? `${checkEmptyValue(selectBedInfo.patientName)} , ${checkEmptyValue(selectBedInfo.devicePatientId)}`: t('trend.notAdmitted')}
                                                </>
                                            ) : (
                                                <>
                                                    { `${currentUserInfo.patientName == t('trend.notAdmitted') ? currentUserInfo.patientName : `${checkEmptyValue(currentUserInfo.patientName)} , ${checkEmptyValue(currentUserInfo.devicePatientId)}`}` }
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                    </div>
                    {
                        isFromSearch &&
                        <div className="ml-3">
                            { `${moment(selectBedInfo.createdAt).format('YYYY-MM-DD HH:mm:ss')} ~ ${selectBedInfo.status !== 'ADMITTED' ? moment(selectBedInfo.updatedAt).format('YYYY-MM-DD HH:mm:ss') : moment(selectBedInfo.endTime).format('YYYY-MM-DD HH:mm:ss')}` }
                        </div>
                    }
                    {
                        !isFromSearch &&
                        currentUserInfo?.flag == 'past' &&
                        <div className="flex items-center text-[#FFF500] ml-3">
                            <IconErrorYellow />
                            <div className="ml-1" style={{ fontWeight: 200, fontSize: 16 }}>{t('trend.notCurrentPatient')}</div>
                        </div>
                    }                    
                    <HalfMenus 
                        selectBedInfo={selectBedInfo}
                        nowPage={'trend'}
                        onTrend={null}
                        onAlarmReview={onAlarmReview}
                        onMeasurements={onMeasurements}
                        onSetting={onSetting}
                        isFull={isTrendFull}
                        isFromSearch={isFromSearch}
                        handleFullScreen={handleFullScreen}
                        onClose={onClose}
                    />
                </div>

                <div className="flex flex-grow text-white" style={{ height: isTrendFull ? '100%' : 'calc(100% - 32px)' }}>
                    <div className="relative flex flex-col flex-grow w-full h-full">
                        <div className="relative" style={{ height: isTrendFull ? (isTrendClose ? '904px' : '534px') : '236px' }}>
                            <TrendWave                              
                                waveStartDate={waveStartDate}
                                waveEndTime={new Date(moment(waveStartDate).add(isTrendFull ? (isTrendClose ? 60 : 40) : 15 , 'minutes'))}
                                zoomTime={timeSettings[trendZoom]['subtract']}
                                trendData={trendData}
                                isTrendFull={isTrendFull}
                                handleChangeTime={(...args) => { handleChangeTime(...args) }}
                                trendWaveType={trendWaveType}
                                handleChangeWaveType={(lead) => { setTrendWaveType(lead)}}
                                handleSelectBoxTimeInfo={handleSelectBoxTimeInfo}                                
                                selectBoxTimeInfo={selectBoxTimeInfo}                                
                                handleLoading={(loadingState) => setLoading(loadingState)}
                                timeSettings={timeSettings}     
                                loading={loading}    
                                handleDoubleClick={handleDoubleClick}
                                isTrendClose={isTrendClose}
                                patientHistories={patientHistories}
                                canSearchMoves={canSearchMoves}
                            />
                        </div>
                        <div className='flex pl-[4px]' style={{ height: isTrendFull ? (isTrendClose ? '0' : '410px') : 'calc(100% - 301px)', display : isTrendFull && isTrendClose ? 'none' : 'flex' }}>
                            <div className='flex flex-col pb-[6px] gap-[2px]'>
                                <div className={`${selectDetailView == 'Arrhythmia' ? 'bg-gradient-to-r from-[#434343] to-[#2F2F2F]' : 'bg-[#171717]'} flex justify-center items-center cursor-pointer p-[8px_10px] rounded-l-[6px]`}
                                    style={{ 
                                        boxShadow: selectDetailView !== 'Arrhythmia' ? 'inset 0 0 0 1px #1F1F1F' : 'none'
                                    }}
                                    onClick={() => setselectDetailView('Arrhythmia')}
                                >
                                    <IconArrhythmia className='w-[28px] h-[28px]' />
                                </div>
                                <div className={`${selectDetailView == 'Tabular Trend' ? 'bg-gradient-to-r from-[#434343] to-[#2F2F2F]' : 'bg-[#171717]'} flex justify-center items-center cursor-pointer p-[8px_10px] rounded-l-[6px]`}
                                    style={{ 
                                        boxShadow: selectDetailView !== 'Tabular Trend' ? 'inset 0 0 0 1px #1F1F1F' : 'none'
                                    }}
                                    onClick={() => setselectDetailView('Tabular Trend')}
                                >
                                    <IconTabularTrend className='w-[28px] h-[28px]' />
                                </div>
                                <div className={`${selectDetailView == 'Strip' ? 'bg-gradient-to-r from-[#434343] to-[#2F2F2F]' : 'bg-[#171717]'} flex justify-center items-center cursor-pointer p-[8px_10px] rounded-l-[6px]`}
                                    style={{
                                        boxShadow: selectDetailView !== 'Strip' ? 'inset 0 0 0 1px #1F1F1F' : 'none'
                                    }}
                                    onClick={() => setselectDetailView('Strip')}
                                >
                                    <IconStrip className='w-[28px] h-[28px]' />
                                </div>
                                <div className={`${selectDetailView == 'Graphic Trend' ? 'bg-gradient-to-r from-[#434343] to-[#2F2F2F]' : 'bg-[#171717]'} flex justify-center items-center cursor-pointer p-[8px_10px] rounded-l-[6px]`}
                                    style={{
                                        boxShadow: selectDetailView !== 'Graphic Trend' ? 'inset 0 0 0 1px #1F1F1F' : 'none'
                                    }}
                                    onClick={() => setselectDetailView('Graphic Trend')}
                                >
                                    <IconGraphicTrend className='w-[28px] h-[28px]' />
                                </div>
                            </div>
                            {renderMenuContent()}
                        </div>
                        {/* isTrendClose 일 경우 다시 열 수 있게. */}
                        {
                            isTrendClose && (
                                <div className="flex justify-between items-center h-[40px] bg-[#2F2F2F] px-[20px]">
                                    <h2 className="text-white text-center font-medium text-lg leading-[110%] font-pretendard">{selectDetailView}</h2>
                                    <div className="flex items-center justify-center cursor-pointer gap-[8px]">                                
                                        <div 
                                            className="flex items-center justify-center cursor-pointer text-white rounded-[4px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] p-[4px]" 
                                            onClick={() => setIsTrendClose(!isTrendClose)}>
                                            <IconArrowUp className="w-[18px] h-[18px] text-white" />
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        <div className='relative h-[65px] bg-[#000000]'>
                            <Timeline                                 
                                patientHistories={patientHistories}
                                patientLatestHistory={patientLatestHistory} 
                                alarmList={alarmList} 
                                startTime={moment.utc(startDate)} 
                                endTime={moment.utc(endDate)}
                                waveStateTime={moment.utc(waveStartDate)}
                                waveEndTime={new Date(moment.utc(waveStartDate).add(isTrendFull ? (isTrendClose ? 60 : 40) : 15 , 'minutes'))}
                                handleChangeTime={(...args) => { handleChangeTime(...args) }}
                                handleDragTimeLine={(date) => handleDragTimeLine(date)}
                                zoomTime={timeSettings[trendZoom]['subtract']}
                                handleTimeSettings={handleTimeSettings}
                                timeLineDuration={timeLineDuration}
                                selectBoxTimeInfo={selectBoxTimeInfo}
                                canSearchMoves={canSearchMoves}
                                trendDuration={isTrendFull ? (isTrendClose ? 60 : 40) : 15}                                
                            />
                        </div>
                    </div>
                </div>
                
            </div>

            {
                isTimeSettings && 
                <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-[999]">
                    <TimelineDateModal 
                        ref={searchModalRef}
                        handleClose={() => setIsTimeSettings(false)}
                        handleSearch={handleTimeLineSearch}
                        timeLineDuration={timeLineDuration}                        
                    />    
                </div>
            }
            {
                isDoubleClick && (
                    <div className="absolute top-[32px] left-0 flex flex-col flex-grow w-full h-full" style={{zIndex: 9999}}>
                        <div className="flex justify-center h-[35px] bg-[#1F1F1F]">                
                            <button onClick={() => setIsDoubleClick(false)} className="absolute rounded-[4px] p-[5px] right-[8px] top-[5px] flex gap-[4px] items-center cursor-pointer bg-gradient-to-b from-[#5e5e5e] to-[#383838] text-[14px] leading-[110%]">
                                <span className='font-medium text-white'>{t('trend.close')}</span>
                                <IconClose className='w-[14px] h-[14px]'/>
                            </button>
                        </div>
                        <div className='flex flex-1 flex-col bg-black'>                            
                            {
                                isTrendFull ? (
                                    doubleClickData &&
                                    doubleClickData.reduce((acc, cur, idx) => {
                                        if (idx % 3 === 0) acc.push([]);
                                        acc[acc.length - 1].push(cur);
                                        return acc;
                                    }, []).map((group, groupIdx) => {                                        
                                        const borderClass = groupIdx === 1 ? 'border border-dotted border-[#fff]' : '';
                                        return (
                                            <div className={`relative flex flex-col ${borderClass}`} key={groupIdx}>
                                                {group.map((data, idx) => {
                                                    const rowIdx = groupIdx * 3 + idx;
                                                    return (
                                                        <div className="relative w-full" key={rowIdx}>
                                                            <div className="absolute top-0 left-0 text-[#fff] px-[10px]">
                                                                {doubleClickType == 'hr'
                                                                    ? moment(data[0].timestamp).format('YYYY-MM-DD HH:mm:ss')
                                                                    : moment(data[0].createdAt).format('YYYY-MM-DD HH:mm:ss')}
                                                            </div>
                                                            <div className="absolute bottom-0 right-0 text-[#fff] px-[10px]">
                                                                {doubleClickType == 'hr'
                                                                    ? moment(data[data.length - 1].timestamp).add(1, 'seconds').format('YYYY-MM-DD HH:mm:ss')
                                                                    : moment(data[data.length - 1].createdAt).add(1, 'seconds').format('YYYY-MM-DD HH:mm:ss')}
                                                            </div>
                                                            <MeasureTime
                                                                data={data}
                                                                width={doubleClickWidth}
                                                                height={isTrendFull ? 105 : 120}
                                                                isHrValueChecked={doubleClickType == 'hr'}
                                                            />
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        );
                                    })
                                ) : (
                                    doubleClickData && doubleClickData.map((data,_)=> (
                                        <div className="relative w-full" key={_}>
                                            <div className="absolute top-0 left-0 text-[#fff] px-[10px]">
                                                {
                                                    doubleClickType == 'hr' ? moment(data[0].timestamp).format('YYYY-MM-DD HH:mm:ss') : moment(data[0].createdAt).format('YYYY-MM-DD HH:mm:ss')
                                                }
                                            </div>
                                            <div className="absolute bottom-0 right-0 text-[#fff] px-[10px]">
                                                {
                                                    doubleClickType == 'hr' ? moment(data[data.length-1].timestamp).add(1, 'seconds').format('YYYY-MM-DD HH:mm:ss') : moment(data[data.length-1].createdAt).add(1, 'seconds').format('YYYY-MM-DD HH:mm:ss')
                                                }                                                     
                                            </div>
                                            <MeasureTime                                                    
                                                data={data}
                                                width={doubleClickWidth}
                                                height={isTrendFull ? 110 : 120}                                                                                                        
                                                isHrValueChecked={doubleClickType == 'hr' ? true : false}                                                                                                        
                                            />
                                        </div>
                                    ))
                                )
                            }
                        </div>
                    </div>
                )
            }
            {
                isStripPrint && (
                    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-[999]">
                        <TrendStripModal
                            handleTrendPrint={handleTrendPrint}
                            onClose={() => setIsStripPrint(false)}
                        />      
                    </div>
                )
            }            
        </div>
    )
}

export default React.memo(TrendReview)